import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function ChildSafetyPolicy() {
  const currentYear = new Date().getFullYear();


   const [termsModalOpen, setTermsModalOpen] = useState(false);
      const [loadingTerms, setLoadingTerms] = useState(true);
       
      const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
      const [loadingPrivacy, setLoadingPrivacy] = useState(true);
  

  return (
    
    <div className="main-wrapper" >
   
      <ToastContainer />
      <div className=" px-2" >

       
        
        {/* Badge + Title */}
        <div className="text-center mb-10">
          <span className="inline-block bg-red-600 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            Zero Tolerance
          </span>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Child Safety &amp; Protection Policy (CSAE)
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Oret Africa strictly prohibits any content or behavior involving the sexual abuse or exploitation of minors.
            We take immediate action on reports and cooperate with law enforcement.
          </p>
        </div>


        {/* Section 1 */}
        <div className='card'>
            <div className='card-body'>

            
        <div className="p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Our Commitment</h2>
          <p className="text-gray-700 mb-3">
            We have a <strong>zero-tolerance</strong> stance toward Child Sexual Abuse and Exploitation (CSAE),
            including any Child Sexual Abuse Material (CSAM). We remove offending content and take action against accounts involved.
          </p>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Prohibit CSAE and CSAM in all forms.</li>
            <li>Act swiftly to remove content and restrict offenders.</li>
            <li>Preserve evidence and support investigations as required by law.</li>
          </ul>
        </div>

        {/* Section 2 */}
        <div className=" p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Report a Concern</h2>
          <p className="text-gray-700 mb-3">
          If you see anything that may involve a minor's safety, please report it <em>immediately</em> using one of these methods:
          </p>
          <ul className="list-disc pl-5 mb-1 text-gray-700">
           
          <li><strong>In-app report</strong>: Use the <em>Report a Concern</em> option in the sidebar menu.</li>

            <li>
              <strong>Email</strong>:{' '}
              <a
                href="mailto:safety@oret.africa?subject=Child%20Safety%20Concern"
                className="text-blue-600 underline"
              >
                safety@oret.africa
              </a>
            </li>
          </ul>
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <p className="font-semibold text-yellow-800">Emergency?</p>
            <p className="text-sm text-yellow-700">
              If a child is in immediate danger, contact your local authorities first. Then notify us with any relevant details so we can assist and preserve evidence.
            </p>
          </div>
        </div>

        {/* Section 3 */}
        <div className="p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">3. How We Handle Reports</h2>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>All CSAE/CSAM reports are reviewed <em>as a priority</em> by our safety team.</li>
            <li>Confirmed CSAM is removed and reported to competent authorities.</li>
            <li>We cooperate with lawful requests and retain evidence as required by applicable law.</li>
          </ul>
        </div>

        {/* Section 4 */}
        <div className=" p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Legal Compliance</h2>
          <p className="text-gray-700">
            We comply with child protection and reporting obligations in regions where we operate.
            We also maintain internal procedures for evidence handling and rapid response to lawful requests.
          </p>
        </div>

        {/* Section 5 */}
        <div className="p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Designated Contact</h2>
          <p className="text-gray-700">
            <strong>Name:</strong> Evans Kiplagat<br />
            <strong>Role:</strong> Child Safety &amp; Trust Coordinator<br />
            <strong>Email:</strong>{' '}

            <a
                href="mailto:safety@oret.africa?subject=Child%20Safety%20Concern"
                className="text-blue-600 underline"
              >
              safety@oret.africa
            </a>
          </p>
        </div>

        {/* Links */}
        <div className="p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">Related Policies</h2>
          <ul className="list-disc pl-5 space-y-1 text-blue-600">
            <li>
            <button onClick={() => setPrivacyModalOpen(true)} className="btn btn-link p-0">
                Privacy Policy
                    </button>
            </li>
            <li>

            <button onClick={() => setTermsModalOpen(true)} className="btn btn-link p-0">
            Terms &amp; Community Guidelines
                    </button>

              
            </li>
          </ul>
        </div>

        </div>
        </div>

        {/* Footer */}
        <footer className="text-center text-gray-500 text-sm mt-8" style={{marginBottom: '20%'}}>
          © {currentYear} Oret Africa • Last updated: August 15, 2025
        </footer>
      </div>


                         {/* modals here*/}
      
                              
            <ReactModal
            isOpen={termsModalOpen}
            onRequestClose={() => setTermsModalOpen(false)}
            className="Modal modal-lg"
            overlayClassName="Overlay"
          >
            <div className="modal-header">
              <h5 className="modal-title">Terms of Use</h5>
              <button
                type="button"
                className="btn-close modalCloseButton"
                onClick={() => setTermsModalOpen(false)}
              ></button>
            </div>
      
            <div
              className="modal-body p-0 position-relative"
              style={{ maxHeight: "80vh", overflow: "hidden" }}
            >
              {loadingTerms && (
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255,255,255,0.8)",
                    zIndex: 10,
                  }}
                >
                  <div className="spinner-border text-primaryx" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
      
              <iframe
                src="https://oret.africa/terms-and-conditions/"
                title="Terms of Use"
                style={{ width: "100%", height: "80vh", border: "none" }}
                onLoad={() => setLoadingTerms(false)}
              ></iframe>
            </div>
      
            <div className="modal-footer"></div>
          </ReactModal>
      
      
      
      
      
          <ReactModal
            isOpen={privacyModalOpen}
            onRequestClose={() => setPrivacyModalOpen(false)}
            className="Modal modal-lg"
            overlayClassName="Overlay"
          >
            <div className="modal-header">
              <h5 className="modal-title">Privacy Policy</h5>
              <button
                type="button"
                className="btn-close modalCloseButton"
                onClick={() => setPrivacyModalOpen(false)}
              ></button>
            </div>
      
            <div
              className="modal-body p-0 position-relative"
              style={{ maxHeight: "80vh", overflow: "hidden" }}
            >
              {loadingPrivacy && (
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255,255,255,0.8)",
                    zIndex: 10,
                  }}
                >
                  <div className="spinner-border text-primaryx" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
      
              <iframe
                src="https://oret.africa/privacy-policy/"
                title="Privacy Policy"
                style={{ width: "100%", height: "80vh", border: "none" }}
                onLoad={() => setLoadingPrivacy(false)}
              ></iframe>
            </div>
      
            <div className="modal-footer"></div>
          </ReactModal>
      


      </div>


      
  );
}

export default ChildSafetyPolicy;
